/**
 * 工序模块枚举定义
 * 
 * @description 定义工序相关的枚举类型
 * @module types/process-operation/enums
 * @category ProcessOperation - 工序管理
 * 
 * @backend-source
 * - Model: backend/app/Modules/ProcessRoute/Models/ProcessOperation.php (line 145-201)
 * 
 * @update-trigger
 * - 后端新增/修改工序类型、质检类型、状态枚举时
 * 
 * @validation
 * ```bash
 * # 验证方法：对照 ProcessOperation Model 的常量定义
 * 1. 枚举值必须与后端常量完全一致
 * 2. 枚举命名使用 PascalCase
 * ```
 * 
 * @last-updated 2025-10-31
 * @status ✅ 已验证
 */

/**
 * 工序类型枚举
 * 
 * @backend ProcessOperation::OPERATION_TYPE_*
 */
export enum ProcessOperationType {
  /** 加工 */
  PROCESSING = 'PROCESSING',
  /** 装配 */
  ASSEMBLY = 'ASSEMBLY',
  /** 检验 */
  INSPECTION = 'INSPECTION',
  /** 包装 */
  PACKAGING = 'PACKAGING',
  /** 运输 */
  TRANSPORT = 'TRANSPORT',
  /** 其他 */
  OTHER = 'OTHER',
}

/**
 * 质检类型枚举
 * 
 * @backend ProcessOperation::INSPECTION_TYPE_*
 */
export enum ProcessInspectionType {
  /** 无 */
  NONE = 'NONE',
  /** 首检 */
  FIRST = 'FIRST',
  /** 巡检 */
  PATROL = 'PATROL',
  /** 终检 */
  FINAL = 'FINAL',
  /** 全检 */
  FULL = 'FULL',
}

/**
 * 工序状态枚举
 * 
 * @backend ProcessOperation::STATUS_*
 */
export enum ProcessOperationStatus {
  /** 启用 */
  ACTIVE = 'ACTIVE',
  /** 停用 */
  INACTIVE = 'INACTIVE',
  /** 淘汰 */
  OBSOLETE = 'OBSOLETE',
}

